<div id="content">
    <div class="titlebox">Contact Rx</div>
    <br><br>
    <div>
        <ag-grid-angular [headerHeight]="35" [rowHeight]="35" style="height: 500px; width: 100%;" (rowDoubleClicked)="navigate($event)" class="ag-theme-alpine" [rowData]="rowPatientContactRx" [columnDefs]="columnPatientContactRx">
        </ag-grid-angular>
    </div>
</div>